const PRESERVED_KEYS = [
  'Tinybots.lang',
  'Tinybots.pwa.installPromptDismissed',
  'Tinybots.pwa.dismissCount',
  'debugLang'
];

export const clearLocalStorageOnLogout = (): void => {
  const preserved: Record<string, string> = {};

  PRESERVED_KEYS.forEach((key) => {
    const value = localStorage.getItem(key);
    if (value !== null) {
      preserved[key] = value;
    }
  });

  localStorage.clear();

  Object.entries(preserved).forEach(([key, value]) => {
    localStorage.setItem(key, value);
  });
};
